import { createMarkup } from "@flexmr/utils";
import type { WidgetConfiguration } from "../types";
import { Widget } from "../Widget";

type Custom = {
	linkTitle: string | null;
	linkPath: string | null;
	textilizedText: string | null;
};

type Props = WidgetConfiguration<Custom>;

export function TermsAndConditions(props: Props): React.ReactNode {
	const { custom, ...rest } = props;

	const { linkTitle, linkPath, textilizedText } = custom;

	const links =
		linkPath && linkTitle
			? { right: { path: linkPath, title: linkTitle } }
			: {};

	return (
		<Widget {...rest} footerLinks={links}>
			<p dangerouslySetInnerHTML={createMarkup(textilizedText ?? "")} />
		</Widget>
	);
}
